import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/accordion-card/accordion-card.js';
      import {Position, AccordionSize} from '@oicl/openbridge-webcomponents/dist/components/accordion-card/accordion-card.js';
import {ObcAlertFrameType, ObcAlertFrameThickness, ObcAlertFrameStatus} from '@oicl/openbridge-webcomponents/dist/components/alert-frame/alert-frame.js';

      export interface Props {
     cardTitle?: string;
     description?: string;
     statusLabel?: string;
     expanded?: boolean;
     disabled?: boolean;
     hasAlert?: boolean;
     hasDescription?: boolean;
     hasStatusLabel?: boolean;
     hasLeadingIcon?: boolean;
     position?: Position;
     size?: AccordionSize;
     alertFrameType?: ObcAlertFrameType;
     alertFrameThickness?: ObcAlertFrameThickness;
     alertFrameStatus?: ObcAlertFrameStatus
   }

      
  
      export type {Position, AccordionSize} from '@oicl/openbridge-webcomponents/dist/components/accordion-card/accordion-card.js';
export type {ObcAlertFrameType, ObcAlertFrameThickness, ObcAlertFrameStatus} from '@oicl/openbridge-webcomponents/dist/components/alert-frame/alert-frame.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcAccordionCard',
  props: {
    cardTitle: {},
    description: {},
    statusLabel: {},
    expanded: { type: Boolean },
    disabled: { type: Boolean },
    hasAlert: { type: Boolean },
    hasDescription: { type: Boolean },
    hasStatusLabel: { type: Boolean },
    hasLeadingIcon: { type: Boolean },
    position: {},
    size: {},
    alertFrameType: {},
    alertFrameThickness: {},
    alertFrameStatus: {}
  },
  emits: ["accordion-toggle"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onAccordionToggle: (event: CustomEvent<{expanded: boolean, cardTitle: string}>) => emit('accordion-toggle', event as CustomEvent<{expanded: boolean, cardTitle: string}>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-accordion-card',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})